import { logger } from './logger';

/**
 * CSS optimization utilities for LCP improvement
 */

// Defer non-critical CSS loading
export const deferNonCriticalCSS = () => {
  // Load non-critical CSS after page load
  const loadCSS = (href: string, media = 'all') => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'print'; // Load as print first to avoid render blocking
    link.onload = () => {
      link.media = media; // Switch to target media after load
    };
    document.head.appendChild(link);
  };

  // Load non-critical stylesheets after page load
  window.addEventListener('load', () => {
    // Defer loading of non-critical CSS files
    const nonCriticalCSS: string[] = [
      // Add any non-critical CSS files here
      // Example: '/assets/non-critical.css'
    ];

    nonCriticalCSS.forEach((css) => loadCSS(css));
  });
};

// Preload critical CSS
export const preloadCriticalCSS = (cssUrls: string[]) => {
  cssUrls.forEach((url) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = url;
    link.onload = () => {
      // Convert preload to stylesheet
      link.rel = 'stylesheet';
    };
    document.head.appendChild(link);
  });
};

// Remove unused CSS classes (basic implementation)
export const removeUnusedCSS = () => {
  // This is a basic implementation - in production, use tools like PurgeCSS
  const allElements = document.querySelectorAll('*');
  const usedClasses = new Set<string>();

  allElements.forEach((element) => {
    element.classList.forEach((className) => {
      usedClasses.add(className);
    });
  });

  logger.log('Used CSS classes:', usedClasses.size);
  return usedClasses;
};

// Optimize font loading
export const optimizeFontLoading = () => {
  // Add font-display: swap to all font faces
  const style = document.createElement('style');
  style.textContent = `
    @font-face {
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
};

// Initialize CSS optimizations
export const initializeCSSOptimizations = () => {
  // Defer non-critical CSS
  deferNonCriticalCSS();

  // Optimize font loading
  optimizeFontLoading();

  logger.log('✅ CSS optimizations initialized for LCP improvement');
};
